// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__GLmHS","row":"Node_row__1dh-J","label":"Node_label__3jLWE","footer":"Node_footer__3Dro7"};